import * as React from 'react'

const SvgBookLessonPayMethodIcon = (props) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#E0EAFF" />
    <g clipPath="url(#clip0_2851_73024)">
      <path
        d="M19.9998 16.6666V20M19.9998 23.3333H20.0082M28.3332 20C28.3332 24.6023 24.6022 28.3333 19.9998 28.3333C15.3975 28.3333 11.6665 24.6023 11.6665 20C11.6665 15.3976 15.3975 11.6666 19.9998 11.6666C24.6022 11.6666 28.3332 15.3976 28.3332 20Z"
        stroke="#444CE7"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2851_73024">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(10 10)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default SvgBookLessonPayMethodIcon
